import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function RequireAdmin({ children }) {
  const token = localStorage.getItem("admintoken");
  const loc = useLocation();
  if (!token) return <Navigate to="/admin/login" state={{ from: loc }} replace />;
  return children;
}
